export const primaryColor = "#4c6ef5";
export const secondaryColor = "#b652dd";
export const greyColor = "#4d4d4d";
